import React from 'react'

import styled from '@emotion/styled'

import { spacing } from '../../../theme'
import ArcadeTooltipIcon, { ArcadeTooltipIconProps } from '../ArcadeTooltipIcon/ArcadeTooltipIcon'

export type FieldLabelProps = {
  label: string
  space?: string // TODO potentially deprecate this if we can move away from custom spacing between field label and input
  tooltipProps?: ArcadeTooltipIconProps
  children?: React.ReactNode
  htmlFor?: string
}

const StyledLabel = styled.label`
  -webkit-tap-highlight-color: transparent;
`

const LabelText = styled.span<{ disabled: boolean }>`
  ${({ theme }) => theme.typography.labelMedium}
  color: ${({ theme, disabled }) =>
    disabled ? theme.arcadeColors.component.inputLabelDisabled : theme.arcadeColors.component.inputLabelDefault};
`

const LabelLayout = styled.span<{ space: string }>`
  display: flex;
  justify-content: space-between;
  margin: 0 0 ${props => props.space};
`

const FieldLabel: React.FC<FieldLabelProps> = ({ label, children, tooltipProps, space = spacing.xs, ...props }) => {
  /* Waiting on wider :has() support in Firefox to be able to remove this check https://developer.mozilla.org/en-US/docs/Web/CSS/:has#browser_compatibility */
  const disabled = React.Children.toArray(children).some(
    child => typeof child === 'object' && 'props' in child && child.props.disabled === true
  )

  // If no label is provided, there should not be extra spacing
  if (!label || label.trim() === '') {
    space = spacing.empty
  }

  return (
    <StyledLabel {...props}>
      <LabelLayout space={space}>
        <LabelText disabled={disabled}>{label}</LabelText>
        {tooltipProps && <ArcadeTooltipIcon {...tooltipProps} />}
      </LabelLayout>
      {children}
    </StyledLabel>
  )
}

export default FieldLabel
